/**
 * @generated SignedSource<<4c87f7d99511c5e737eced450fcfa992>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionRetry_viewer$data = {
  readonly nftTokenContractImportById: {
    readonly serviceId: string | null;
  } | null;
  readonly publicProfile: {
    readonly username: string | null;
  } | null;
  readonly " $fragmentType": "NftProfileImportCollectionRetry_viewer";
};
export type NftProfileImportCollectionRetry_viewer$key = {
  readonly " $data"?: NftProfileImportCollectionRetry_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionRetry_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "tokenContractId"
    },
    {
      "kind": "RootArgument",
      "name": "username"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionRetry_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "username",
          "variableName": "username"
        }
      ],
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "tokenContractId",
          "variableName": "tokenContractId"
        }
      ],
      "concreteType": "NftTokenContractImport",
      "kind": "LinkedField",
      "name": "nftTokenContractImportById",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7a68d2562c3efe32f128ab7b03290dce";

export default node;
